module.exports = __webpack_public_path__ + "img/map_8.94918bfa.png";